import { visibleCanvas, width, height } from './utils'
import { style, highlighted, findById } from './node'
import * as draw from './draw'

export const tick = (canvas: HTMLElement = visibleCanvas()): void => {
  const context: CanvasRenderingContext2D = canvas.getContext('2d')
  const container: object = globalThis._CONTAINER_
  const simulation: object = globalThis._SIMULATION_
  const visible: boolean = canvas === visibleCanvas()

  simulation.nodes().forEach(node => {
    node.style = visible ? style(node) : 'hidden'
    node.highlighted = highlighted(node)
  })

  context.save()
  draw.reset(context, visible)

  container.selectAll('link').each(function (d) {
    if (d.hidden === true || !visible) return
    draw.link(context, d)
  })

  container.selectAll('node').each(function (node) {
    draw.node(context, node, visible)
  })

  recenter()

  if (globalThis._CONFIGURATION_.branding.display === true && visible) draw.brandingImage(context)

  context.restore()
}

const recenter = (): void => {
  if (globalThis._CONFIGURATION_.centered === undefined || globalThis._CONFIGURATION_.centered === null) return

  const node = findById(globalThis._CONFIGURATION_.centered)

  // Corner distance from origin
  const x0: number = globalThis._TRANSFORM_.x
  const y0: number = globalThis._TRANSFORM_.y

  // Node location
  const xN: number = globalThis._TRANSFORM_.applyX(node.x)
  const yN: number = globalThis._TRANSFORM_.applyY(node.y)

  // Node distance from origin
  const xD: number = 0 - xN
  const yD: number = 0 - yN

  // Offset to center
  const xC: number = width() * 0.5
  const yC: number = height() * yOffset(node)

  const x1: number = xD + x0 + xC
  const y1: number = yD + y0 + yC

  globalThis._TRANSFORM_.x = x1
  globalThis._TRANSFORM_.y = y1
}

const yOffset = (node: object): number => {
  return (node.cardable === true && window.innerWidth <= 768) ? 0.2 : 0.5
}
